import { membershipService } from './membership.service';

export const subscriptionService = {
  async validateGymSubscription() {
    const membershipStatus = await membershipService.getStatus();
    return membershipStatus;
  },

  isValidMembershipStatus(status) {
    if (!status) return false;
    return !status.expired && status.valid !== false;
  },
};
